import { ClinicProduct } from '../../types';

export const MOCK_PRODUCTS: ClinicProduct[] = [
  {
    id: 'p-001',
    nameEn: 'Lonicera japonica',
    brand: 'Tongrentang',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'LEAVES_FLOWERS',
    tags: ['SPECIAL'],
    properties: ['Leaves & flowers', 'Heat-Clearing', 'Cooling the blood'],
    unit: '10g',
    spec: 'Dried, premium grade',
    priceUnit: '/10g',
    salePrice: 9.99,
    originalPrice: 15.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 240,
    moq: 1,
    infoSections: [
      { key: 'GENERAL', body: 'Lonicera japonica (Jin Yin Hua) is a flowering herb traditionally used in TCM for clearing heat and toxins.' },
      { key: 'INGREDIENTS', body: 'Pure dried Lonicera japonica flowers, harvested at peak bloom.' },
      { key: 'DIRECTIONS', body: 'Brew 5–10g in 200ml hot water, steep for 5 minutes. Up to 2 servings per day.' },
      { key: 'WARNINGS', body: 'Avoid use during pregnancy without practitioner guidance.' },
    ],
  },
  {
    id: 'p-002',
    nameEn: 'Forsythia fruit',
    brand: 'Tongrentang',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'FRUITS_SEEDS',
    tags: ['FREQUENT'],
    properties: ['Fruits & seeds', 'Heat-Clearing'],
    unit: '10g',
    spec: 'Dried fruits',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 530,
    moq: 1,
    infoSections: [
      { key: 'GENERAL', body: 'Forsythia (Lian Qiao) is paired with Honeysuckle for heat-clearing formulas.' },
      { key: 'DIRECTIONS', body: 'Decoct 6–15g per serving.' },
    ],
  },
  {
    id: 'p-003',
    nameEn: 'Isatis indigotica',
    brand: 'Yunnan Baiyao',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'ROOT_RHIZOME',
    properties: ['Root & rhizome', 'Heat-Clearing'],
    unit: '10g',
    spec: 'Dried root slices',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 410,
    moq: 1,
    infoSections: [
      { key: 'GENERAL', body: 'Isatis root (Ban Lan Gen) is widely used for throat and seasonal complaints.' },
    ],
  },
  {
    id: 'p-004',
    nameEn: 'Isatis indigotica (premium)',
    brand: 'Tongrentang',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'ROOT_RHIZOME',
    properties: ['Root & rhizome'],
    unit: '10g',
    spec: 'Premium grade slices',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 320,
    moq: 1,
  },
  {
    id: 'p-005',
    nameEn: 'Isatis leaf',
    brand: 'Beijing TRT',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'LEAVES_FLOWERS',
    properties: ['Leaves & flowers'],
    unit: '10g',
    spec: 'Dried leaf, finely cut',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 280,
    moq: 1,
  },
  {
    id: 'p-006',
    nameEn: 'Taraxacum mongolicum',
    brand: 'Tasly',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'WHOLE_HERB',
    properties: ['Leaves & flowers', 'Heat-Clearing'],
    unit: '10g',
    spec: 'Dried whole herb',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 190,
    moq: 1,
  },
  {
    id: 'p-007',
    nameEn: 'Wild Chrysanthemum',
    brand: 'Tongrentang',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'LEAVES_FLOWERS',
    properties: ['Leaves & flowers', 'Cooling'],
    unit: '10g',
    spec: 'Dried whole flower',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'LOW_STOCK',
    availableStock: 18,
    moq: 1,
  },
  {
    id: 'p-008',
    nameEn: 'Indigo Naturalis',
    brand: 'Yunnan Baiyao',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'MINERAL',
    tags: ['SPECIAL'],
    properties: ['Mineral'],
    unit: '10g',
    spec: 'Indigo powder',
    priceUnit: '/10g',
    salePrice: 9.99,
    originalPrice: 15.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 60,
    moq: 1,
  },
  {
    id: 'p-009',
    nameEn: 'Coptis chinensis',
    brand: 'Beijing TRT',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'ROOT_RHIZOME',
    properties: ['Root & rhizome', 'Heat-Clearing'],
    unit: '10g',
    spec: 'Dried rhizome',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 120,
    moq: 1,
  },
  {
    id: 'p-010',
    nameEn: 'Baikal skullcap root',
    brand: 'Tasly',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'ROOT_RHIZOME',
    properties: ['Root & rhizome'],
    unit: '10g',
    spec: 'Dried root slices',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 200,
    moq: 1,
  },
  {
    id: 'p-011',
    nameEn: 'Sophora root',
    brand: 'Tongrentang',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'ROOT_RHIZOME',
    properties: ['Root & rhizome'],
    unit: '10g',
    spec: 'Dried root',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'OUT_OF_STOCK',
    availableStock: 0,
  },
  {
    id: 'p-012',
    nameEn: 'Sophora flowers',
    brand: 'Generic',
    productType: 'PHYSICAL',
    category: 'CHINESE_HERB',
    herbOrigin: 'LEAVES_FLOWERS',
    properties: ['Leaves & flowers'],
    unit: '10g',
    spec: 'Dried flowers',
    priceUnit: '/10g',
    salePrice: 9.99,
    gstRate: 0,
    stockStatus: 'IN_STOCK',
    availableStock: 175,
    moq: 1,
  },
];
